// Turn a model field key into a human label for activity/history views:
// drop a trailing "Id"/"Ids", split camelCase, and Title-Case it.
// e.g. "assignedToTeamId" → "Assigned To Team", "clientId" → "Client".
export function prettyFieldLabel(field) {
  return String(field || '')
    .replace(/Ids?$/i, '')
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .replace(/[_-]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

export default prettyFieldLabel;
